import { render, staticRenderFns } from "./PresentationsModule.vue?vue&type=template&id=4edc66b0"
import script from "./PresentationsModule.vue?vue&type=script&lang=ts"
export * from "./PresentationsModule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports